import { render, staticRenderFns } from "./ReviewOrderLaborModal.vue?vue&type=template&id=55ae2329&"
import script from "./ReviewOrderLaborModal.vue?vue&type=script&lang=js&"
export * from "./ReviewOrderLaborModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports